<template>
  <el-row :gutter="8">
    <el-col :xs="24"
            :sm="10"
            :md="8"
            :lg="5"
            :xl="4">
      <avatar-upload></avatar-upload>
      <el-card>
        <div slot="header"
             class="card-title">
          <span>Status</span>
        </div>
        <div class="card-item">
          <span>Permissions:</span>
          <span>{{form.role===1?'Admin':'User'}}</span>
        </div>

        <!-- <div class="card-item">
          <span>Last Login:</span>
          <span>2018/09/01</span>
        </div> -->
        <div class="card-item">
          <span>Active:</span>
          <span v-show="form.active">Yes</span>
          <span v-show="!form.active">No</span>
        </div>
        <div style="text-align:center;">
          <el-button size="mini"
                     icon="el-icon-message"
                     type="danger"
                     @click="confirmSend"
                     round>Reset Password</el-button>
        </div>
      </el-card>
    </el-col>
    <el-col :md="16"
            :sm="14"
            :lg="19"
            :xl="20">
      <el-card>
        <el-form ref="form"
                 :model="form"
                 label-position="left">

          <el-form-item label="Email">
            <el-input v-model="form.email"
                      ></el-input>
          </el-form-item>
          <el-form-item label="Publisher">
            <el-checkbox-group v-model="form.co">
              <el-checkbox label="MP"
                           name="co"></el-checkbox>
              <el-checkbox label="BEP"
                           name="co"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="AUTHOR NAME">
            <el-input v-model="form.bookName"
                      placeholder="AUTHOR NAME"></el-input>
          </el-form-item>
          <el-form-item label="INCOME TAX AUTHOR NAME">If different from Author Name
            <el-input v-model="form.incomeName"
                      placeholder="If different from Author Name"></el-input>
          </el-form-item>
          <el-form-item label="ADDRESS">
            <el-input v-model="form.address"
                      placeholder="ADDRESS"></el-input>
          </el-form-item>
          <el-form-item label="BIOGRAPHY">
            <el-input type="textarea"
                      :rows="5"
                      v-model="form.biography"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       @click="updateProfile">Update</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import AuthHelper from '../../utils/auth.js';
import AvatarUpload from '../user/AvatarUpload';
export default {
  created() {
    this.axios({
      method: 'get',
      url: `/user/${this.$route.params.userID}/profile`,
    }).then(res => {
      this.form = res.data.user;
    });
  },
  components: { AvatarUpload },
  data() {
    return {
      form: {},
      userRole: AuthHelper.getRole(),
    };
  },
  methods: {
    updateProfile() {
      this.axios({
        method: 'put',
        url: `/user/${this.$route.params.userID}/profile`,
        data: this.form,
      }).then(res => {
        this.$message({
          message: 'Profile update success!',
          type: 'success',
        });
      });
    },
    confirmSend() {
      this.$confirm(
        `Do you want to reset this user's password and send activate eMail again`,
        'Info',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning',
        }
      )
        .then(() => {
          this.axios({
            method: 'post',
            url: `/user/${this.$route.params.userID}/send-active`,
          }).then(() => {
            this.$message({
              type: 'success',
              message: 'Sent',
            });
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Reset user password canceled.',
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  &.card-item {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/UserEdit.vue